import { FC, useState } from "react";
import { Link } from "react-router-dom";
import GSA from "../../assets/gsa_contract.jpg";
import NAVSEA from "../../assets/NAVSEA_logo.jpg";
import CIOSP3_SB from "../../assets/CIOSP3_SB.jpg";
import { naics } from "./NAICS.json";
import "./ContractVehicles.scss";

import CustomerListData from "../About/CustomerList/CustomerList.json";
import { CustomerList } from "../About/CustomerList/CustomerList";

interface IListItem {
  name: string;
  link?: string;
}

interface ICustomers {
  entity: string;
  departments: IListItem[];
}

export const ContractVehicles: FC = () => {
  return (
    <div className="ContractVehicles">
      <div className="ContractVehicles__header page-header">
        <h1>Contract Engagement</h1>
        <p>
          With multiple prime contract vehicles, PROSOFT is accessible for a
          wide area of technical support and services ranging our customers’
          needs.
        </p>
      </div>
      <div className="ContractVehicles__body">
        <div className="ContractVehicles__body__section">
          <h2 className="section-header">Contract Vehicles</h2>
          <div className="ContractVehicles__body__section__contract">
            <div className="contract-img">
              <img src={GSA} alt="GSA Contract" />
            </div>
            <div className="ContractVehicles__body__section__contract__content">
              <h2>Schedule 70 - IT Services</h2>
              <p>
                Our GSA Schedule, including Information for Ordering Offices,
                Terms and Conditions, Labor Category Descriptions, and Labor
                Rates, is provided for your review.
              </p>
              <Link className="contract-info-btn" to="/schedule70">
                View Contract Info
              </Link>
            </div>
          </div>
          <div className="ContractVehicles__body__section__contract">
            <div className="contract-img">
              <img src={NAVSEA} alt="NAVSEA" />
            </div>
            <div className="ContractVehicles__body__section__contract__content">
              <h2>NAVSEA - Seaport-E</h2>
              <p>
                The PROSOFT Seaporte Team is pleased to have been awarded a
                Seaport Enhanced Multiple Award Contract (N00178-04-D-4107).
              </p>
            </div>
          </div>
          <div className="ContractVehicles__body__section__contract">
            <div className="contract-img">
              <img src={NAVSEA} alt="NAVSEA" />
            </div>
            <div className="ContractVehicles__body__section__contract__content">
              <h2>NAVSEA - Seaport-NxG</h2>
              <p>
                The PROSOFT Seaport-NxG Team is pleased to have been awarded a
                Seaport-NxG Multiple Award Contract (N00178-19-D-8340).
              </p>
              <Link className="contract-info-btn" to="/seaportNxG">
                View Contract Info
              </Link>
            </div>
          </div>
          <div className="ContractVehicles__body__section__contract">
            <div className="contract-img">
              <img
                src={CIOSP3_SB}
                alt="Chief Information Officer-Solutions and Partners 3"
              />
            </div>
            <div className="ContractVehicles__body__section__contract__content">
              <h2>NITAAC - CIO-SP3 Small Business</h2>
              <p>
                The Chief Information Officer-Solutions and Partners 3 (CIO-SP3)
                Small Business Government-Wide Acquisition Contract (GWAC) is a
                ten (10) year Indefinite Delivery/Indefinite Quantity (IDIQ)
                contract. This contract is intended to provide information
                technology (IT) solutions and services as defined in FAR
                2.101(b) and further clarified in the Clinger-Cohen Act of 1996.
                These IT solutions and services include, but are not limited to,
                health and biomedical-related IT services to meet scientific,
                health, administrative, operational, managerial, and information
                management requirements.
              </p>
              <Link className="contract-info-btn" to="/cio">
                View Contract Info
              </Link>
            </div>
          </div>
        </div>
        <div className="ContractVehicles__body__section ContractVehicles__body__naics">
          <h2 className="section-header">NAICS</h2>
          <div className="ContractVehicles__body__section__content ContractVehicles__body__naics__content">
            <div className="row">
              <div className="col col-code col-header">Code</div>
              <div className="col col-title col-header">Title</div>
            </div>
            {naics.map((obj) => {
              return (
                <div className="row">
                  <div className="col col-code">{obj.code}</div>
                  <div className="col col-title">{obj.title}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="ContractVehicles__body__section">
          <h2 className="section-header">Customers</h2>
          <div className="About_Customers-list About__section__content">
            {(() => {
              return Object.values<ICustomers>(
                CustomerListData.customers.sort(
                  (a: ICustomers, b: ICustomers) => {
                    if (a.departments.length > b.departments.length) return -1;
                    else return 1;
                  }
                )
              ).map((value) => {
                return (
                  <CustomerList
                    listHeader={value.entity}
                    listItems={value.departments}
                  />
                );
              });
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};
